import { FileTemplateResult, ForumSeminarSessionsImportErrorFile } from "generated/api";

export interface DownloadFileData {
  name: string;
  content: Uint8Array;
  contentType: string;
}

export const base64ToUint8Array = (base64: string): Uint8Array => {
  const binary = atob(base64);
  const len = binary.length;
  const bytes = new Uint8Array(len);

  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes;
};

export const downloadBinaryFile = (data: DownloadFileData) => {
  const blob = new Blob([new Uint8Array(data.content)], { type: data.contentType });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = data.name;
  link.click();

  URL.revokeObjectURL(url);
};

export const extractErrorFile = (response: ForumSeminarSessionsImportErrorFile): DownloadFileData | null => {
  if (!response.errorFileContent || !response.errorFileContentType) return null;

  return {
    name: response.errorFileName ?? "import-error",
    content: base64ToUint8Array(response.errorFileContent),
    contentType: response.errorFileContentType,
  };
};

export const extractTemplateFile = (response: FileTemplateResult): DownloadFileData | null => {
  if (!response.templateFile || !response.templateContentType) return null;

  return {
    name: response.templateName ?? "TemplateFile",
    content: base64ToUint8Array(response.templateFile),
    contentType: response.templateContentType,
  };
};
